export default __webpack_public_path__ + "static/media/adam.4cb1cf29.jpg";